import { For, createSignal, type JSX } from "solid-js";
import { Modal } from "./Modal";

interface ConfirmActionProps {
  title: string;
  target: string;
  confirmLabel: string;
  impacts: string[];
  strong?: boolean;
  tone?: "primary" | "danger";
  onCancel: () => void;
  onConfirm: () => Promise<boolean>;
}

export function ConfirmAction(props: ConfirmActionProps): JSX.Element {
  const [confirmation, setConfirmation] = createSignal("");
  const [busy, setBusy] = createSignal(false);

  const canSubmit = (): boolean => !props.strong || confirmation() === props.target;

  async function submit(): Promise<void> {
    if (!canSubmit() || busy()) return;
    setBusy(true);
    try {
      if (await props.onConfirm()) props.onCancel();
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal
      title={props.title}
      eyebrow="影响确认"
      onClose={props.onCancel}
      busy={busy()}
      footer={
        <>
          <button type="button" class="button button--ghost" disabled={busy()} onClick={props.onCancel}>
            取消
          </button>
          <button
            type="button"
            class={`button ${props.tone === "danger" ? "button--danger" : "button--primary"}`}
            disabled={!canSubmit() || busy()}
            onClick={() => void submit()}
          >
            {busy() ? "正在提交…" : props.confirmLabel}
          </button>
        </>
      }
    >
      <div class="impact-box">
        <p class="impact-box__target">目标：{props.target}</p>
        <ul>
          <For each={props.impacts}>{(impact) => <li>{impact}</li>}</For>
        </ul>
      </div>
      {props.strong ? (
        <label class="field">
          <span>输入目标名称以确认</span>
          <input
            autocomplete="off"
            value={confirmation()}
            onInput={(event) => setConfirmation(event.currentTarget.value)}
            placeholder={props.target}
          />
        </label>
      ) : null}
    </Modal>
  );
}
